import type {OmitStrict} from 'type-zoo'
import type {TMillions} from '@kapitalist/contract/types/millions'
import type {TMinorActionPromptPaySomethingBaseData} from '~/game/types'
import type GamePlayer from '~/models/game/GamePlayer'
import type {TMinorActionPromptValidResponseData} from '~/models/game/MinorActionPrompt'
import MinorActionPrompt from '~/models/game/MinorActionPrompt'
import type {AnyMinorAction} from '~/models/game/types'

type PublicMembersFromApi = OmitStrict<
  TMinorActionPromptPaySomethingBaseData,
  'type'
>

export default abstract class MinorActionPromptPaySomething<
  DataType extends TMinorActionPromptPaySomethingBaseData,
>
  extends MinorActionPrompt<DataType>
  implements PublicMembersFromApi
{
  millionsOwed: TMillions

  constructor(data: DataType, majorActor: GamePlayer, minorActor: GamePlayer) {
    super(data, majorActor, minorActor)
    this.millionsOwed = data.millionsOwed
  }

  // override from MinorActionPrompt
  public validResponses(
    data: TMinorActionPromptValidResponseData
  ): AnyMinorAction[] {
    // the server should not send minor action prompts to pay something to players that can't pay anything
    const totalValue = data.portfolio.totalValue()
    if (totalValue <= 0) {
      throw new Error(
        'Minor action to pay rent received by a player with no portfolio value.'
      )
    }

    return super.validResponses(data)
  }
}
